import React from 'react';
import { styled } from '@mui/material';

import { Box, Container } from 'shell/components';
import { useViewport } from 'contexts/viewport';

const Mobile = ({ renderPage }) => {
    const { device } = useViewport();
    return (
        <Container device={device}>
            <RootBox>{renderPage()}</RootBox>
        </Container>
    );
};

const RootBox = styled(Box)(() => {
    return {
        width: '100%',
        minHeight: 'calc(100vh - 64px - 20px)',
    };
});

export default Mobile;
